export const colorClasses: Record<string, Record<string, string>> = {
	primary: {
		red: "text-primaryRed bg-lightRed hover:bg-darkRed",
		blue: "text-primaryBlue bg-lightBlue hover:bg-darkBlue",
		green: "text-primaryGreen bg-lightGreen hover:bg-darkGreen",

		roseWhite: "text-primaryRoseWhite bg-lightRoseWhite hover:bg-darkRoseWhite",
		purple: "text-primaryPurple bg-lightPurple hover:bg-darkPurple",
		violet: "text-primaryViolet bg-lightViolet hover:bg-darkViolet",
		mutedViolet: "text-primaryMutedViolet bg-lightMutedViolet hover:bg-darkMutedViolet",

		default: "text-white bg-lightPurple hover:bg-darkPurple",
	},
	secondary: {
		red: "text-darkRed bg-lightRed hover:bg-primaryRed",
		blue: "text-white bg-primaryBlue hover:bg-secondaryBlue",
		green: "text-white bg-primaryGreen hover:bg-secondaryGreen",

		roseWhite: "text-darkRoseWhite bg-lightRoseWhite hover:bg-primaryRoseWhite",
		purple: "text-darkPurple bg-lightPurple hover:bg-primaryPurple",
		violet: "text-darkViolet bg-lightViolet hover:bg-primaryViolet",
		mutedViolet: "text-darkMutedViolet bg-lightMutedViolet hover:bg-primaryMutedViolet",

		default: "text-darkPurple bg-lightPurple hover:bg-primaryPurple",
	},
};
